/**
 * `Storage` access that never throws. A browser with storage disabled, or a
 * full one, throws on every call; these read as `null` and drop writes, so
 * callers that can fall back to memory keep working.
 */

export function readGuarded(storage: Storage, key: string): string | null {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

export function writeGuarded(
  storage: Storage,
  key: string,
  value: string
): void {
  try {
    storage.setItem(key, value);
  } catch {
    // Disabled or full storage leaves the value unwritten.
  }
}

export function removeGuarded(storage: Storage, key: string): void {
  try {
    storage.removeItem(key);
  } catch {
    // As above.
  }
}
